import { BizPlanNav } from '@/components/businessPlan/BizPlanNav';
import { BizPlanHero } from '@/components/businessPlan/BizPlanHero';
import { RevenueModelCards } from '@/components/businessPlan/RevenueModelCards';
import { UnitEconomicsChart } from '@/components/businessPlan/UnitEconomicsChart';
import { MarketAnalysis } from '@/components/businessPlan/MarketAnalysis';
import { FinancialProjections } from '@/components/businessPlan/FinancialProjections';
import { ProductRoadmap } from '@/components/businessPlan/ProductRoadmap';
import { RiskMatrix } from '@/components/businessPlan/RiskMatrix';

export function BusinessPlanPanel() {
  return (
    <div
      className="min-h-screen text-white"
      style={{ background: 'linear-gradient(135deg, #0F1B2E 0%, #1A365D 50%, #0F3D2E 100%)' }}
    >
      {/* Grid overlay */}
      <div
        className="pointer-events-none fixed inset-0 z-0 opacity-[0.03]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)',
          backgroundSize: '64px 64px',
        }}
      />

      <div className="relative z-10">
        <BizPlanNav />
        <BizPlanHero />
        <RevenueModelCards />
        <UnitEconomicsChart />
        <MarketAnalysis />
        <FinancialProjections />
        <ProductRoadmap />
        <RiskMatrix />

        {/* Footer */}
        <footer className="border-t border-white/10 py-12">
          <div className="mx-auto max-w-6xl px-4 text-center sm:px-6">
            <p className="text-sm text-slate-500">
              Migro Servicios y Remesas SL — Business Plan Interactivo
            </p>
            <p className="mt-1 text-xs text-slate-600">
              Generado por analisis de 5 repositorios, 112 tablas, 500+ endpoints, 30+ tecnologias.
              Abril 2026.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}
